export const LINK_PRIVACY_POLICY = 'https://www.ecover.com/privacy-policy/'
